import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { AdvancedCommerceListingFiltersAttributeComponentDef } from '@df/module-advanced-commerce';
import { FacetUrlModule } from '@df/module-facet-url/facet-url.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SwatchComponent } from 'projects/app-default/src/app/catalog/attribute/swatch/swatch.component';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { CheckboxComponent } from 'projects/app-default/src/app/ui/form/checkbox';

@Component({
    selector: 'ac-filter-attribute-option',
    templateUrl: '../../../../catalog/ui/listing/filter/filter-attribute-option.html',
    styleUrl: '../../../../catalog/ui/listing/filter/filter-attribute-option.scss',
    standalone: true,
    imports: [NgClass, GridModule, HrefComponent, FacetUrlModule, SwatchComponent, CheckboxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceFilterAttributeOptionComponent
    extends AdvancedCommerceListingFiltersAttributeComponentDef
    implements NListing.IFilterAttr
{
    readonly client = inject(Client);
    readonly app = inject(App);

    optionsWithMatches = computed(() => {
        const allOptions = this.filter().options;
        return allOptions && allOptions.filter(option => (option.count ?? 0) > 0 || ((option.count ?? 0) === 0 && option.selected));
    });

    clear(event: Event) {
        event.preventDefault();
        this.store.filtersResetSelection();
    }
    get zippyId() {
        return ['filter', this.filter().id];
    }
    getSelectedOptionsForFilter(lengthLimit = 20): string | undefined {
        const options = this.options
            ?.filter(option => option.selected)
            .map(i => i.label)
            .join(', ');
        return options && options.length > lengthLimit && options.indexOf(',', lengthLimit) !== -1
            ? options.slice(0, options.indexOf(',', lengthLimit)) + '...'
            : options;
    }

    get isDefaultOpen(): boolean {
        return false;
    }

    get label(): string | undefined {
        return this.filter().label;
    }

    get id(): string {
        return this.filter().id;
    }

    get isSwatch(): boolean {
        return !!this.filter().isSwatch;
    }

    get isColorAttribute(): boolean {
        return this.filter().code === 'color' || this.isSwatch;
    }

    get isSizeAttribute(): boolean {
        return this.filter().code === 'size';
    }

    get options() {
        return this.optionsWithMatches();
    }

    get hasAnyCurrentMatches(): boolean {
        return !!this.options?.filter(option => !!option?.count)?.length;
    }

    getCurrentMatchesCount(option): number {
        return option.count;
    }

    isSelected(option): boolean {
        return option.selected;
    }

    toggle(option): void {
        this.pickOption(option);
    }

    protected isOptionDisabled(option): boolean {
        return !option?.count || option.count === 0;
    }

    get sortedOptionsWithMatches() {
        return this.optionsWithMatches;
    }
    protected getOptionLink(option): string | undefined {
        return undefined;
    }
}
